import * as Yup from "yup";

const automaticValidationSchema = (data) => {
  // console.log("data: ", data);
  let schema = Yup.object().shape({});

  data.forEach((field) => {
    // Extract field properties with defaults for optional values
    const {
      name,
      label = "",
      validation = {},
      validationErrorMessages = {},
      dataType = "string",
      visibilityConditions = [],
    } = field;

    let fieldSchema;

    // Construct fieldSchema based on dataType
    switch (dataType.toLowerCase()) {
      case "string":
      case "date":
        fieldSchema = Yup.string().trim();

        if (validation.minLength) {
          fieldSchema = fieldSchema.min(
            validation.minLength,
            `${label} must have a minimum length of ${validation.minLength}`
          );
        }
        if (validation.maxLength) {
          fieldSchema = fieldSchema.max(
            validation.maxLength,
            ({ max }) => `${label} must have a maximum length of ${max}`,
            { max: validation.maxLength }
          );
        }
        if (validation.regex) {
          fieldSchema = fieldSchema.matches(
            new RegExp(validation.regex),
            validationErrorMessages.regexErrorMessage ||
              `${label} must match the specified pattern`
          );
        }
        if (validation.email) {
          fieldSchema = fieldSchema.email("Invalid email address");
        }
        if (validation.url) {
          fieldSchema = fieldSchema.url("Invalid URL");
        }
        break;
      case "boolean":
        fieldSchema = Yup.boolean();

        break;
      case "number":
        fieldSchema = Yup.string().trim();

        if (validation.minLength) {
          fieldSchema = fieldSchema.min(
            validation.minLength,
            `${label} must be minimum ${validation.minLength} characters`
          );
        }
        if (validation.maxLength) {
          fieldSchema = fieldSchema.max(
            validation.maxLength,
            `${label} must be maximum ${validation.maxLength} characters`
          );
        }
        if (validation.regex) {
          fieldSchema = fieldSchema.matches(
            new RegExp(validation.regex),
            validationErrorMessages.regexErrorMessage ||
              `${label} must match the specified pattern`
          );
        }

        break;
      case "object":
        fieldSchema = automaticValidationSchema(field.obj);
        break;
      case "array":
        fieldSchema = Yup.array().of(automaticValidationSchema(field.obj));
        break;
      default:
        fieldSchema = Yup.string();
        break;
    }

    if (visibilityConditions.length > 0) {
      // TODO: Handle visibilityConditionLogic (OR, AND)
      visibilityConditions.forEach((visibilityCondition) => {
        const { name, value, type } = visibilityCondition;
        fieldSchema = fieldSchema.when(name, {
          is: (val) => {
            switch (type) {
              case "==":
                return (val || "") === value;
              case "!=":
                return (val || "") !== value;
              case ">":
                return (val || "") > value;
              case ">=":
                return (val || "") >= value;
              case "<":
                return (val || "") < value;
              case "<=":
                return (val || "") <= value;
              default:
                return false;
            }
          },
          then: (schema) => {
            if (validation.required) {
              return schema.required(
                validationErrorMessages.requiredErrorMessage ||
                  `${label} is required`
              );
            }
            return schema;
          },
        });
      });
    } else if (validation.required) {
      fieldSchema = fieldSchema.required(
        field.requiredErrorMessage || `${label} is required`
      );
    }

    // Add field schema to main schema
    schema = schema.concat(Yup.object().shape({ [name]: fieldSchema }));
  });

  return schema;
};

export default automaticValidationSchema;
